export default "__VITE_ASSET__BdrmOrLr__"